import { useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { CSSTransition } from "react-transition-group";

import "components/Ui/WalletPanel/walletPanel.scss";

/**
 * The one modal frame both wallets open in — the driver's and the
 * restaurant's (admin#41). Same width, same header, same close, so the two
 * screens look like one feature.
 *
 * @param {object} props
 * @param {boolean} props.show
 * @param {Function} props.close
 * @param {string} props.title
 * @param {import("react").ReactNode} props.children Rendered only while shown.
 */
const WalletModal = ({ show, close, title, children }) => {
    const nodeRef = useRef();

    return (
        <div className={`model ${show ? "model-show" : ""}`} onClick={close}>
            <CSSTransition
                mountOnEnter
                unmountOnExit
                nodeRef={nodeRef}
                in={show}
                timeout={400}
                classNames="show"
            >
                <div
                    className="addItem wallet-modal"
                    ref={nodeRef}
                    onClick={(e) => e.stopPropagation()}
                >
                    <div className="head center">
                        <h5>{title}</h5>
                        <FontAwesomeIcon icon={faClose} onClick={close} />
                    </div>
                    {show ? children : null}
                </div>
            </CSSTransition>
        </div>
    );
};

export default WalletModal;
